<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      center
      width="500px"
    >
      <el-form label-width="180px">
        <div
          style="
            text-align: center;
            color: #909399;
            margin-top: -10px;
            margin-bottom: 20px;
          "
        >
          启用 或 禁用 会关闭所有游戏相应链的入口
        </div>
        <el-form-item
          v-for="(item, index) in mFormData"
          :key="index"
          :label="item.Chain"
        >
          <el-radio-group v-model="item.State">
            <el-radio label="1">{{$t('Enable')}}</el-radio>
            <el-radio label="2">{{$t('deactivate')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')" prop="GoogleCode">
          <el-input v-model="mGoogleCode" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogData.show = false">{{$t('Cancel')}}</el-button>
        <el-button type="primary" @click="submitForm()">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/api/base.js";
import { app } from "@/api/app.js";
export default {
  extends: base,
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mFormData: [],
      mGoogleCode: "",
    };
  },
  created() {
    this.app = app;
    this.OnReqGameLinkSwitch();
  },
  methods: {
    OnReqGameLinkSwitch() {
      let tData = { SellerId: this.filters.SellerId };
      app.post("/game/chain_list", tData, (res) => {
        if (res.code == 200) {
          let tList = res.data || [];
          let nIndex = -1;
          tList.forEach((element, index) => {
            element.State = String(element.State);
            // 转账玩法都是波场链，所以不能对波场链进行开关控制，过滤掉
            if (element.ChainType == 1) {
              nIndex = index;
            }
          });
          if (nIndex >= 0) {
            tList.splice(nIndex, 1);
          }
          this.mFormData = tList;
        }
      });
    },
    submitForm() {
      if (!this.mGoogleCode) {
        return this.$message.error(this.$t('EnterGoogleVerificationCode'));
      }
      let tData = {
        SellerId: this.filters.SellerId,
        GoogleCode: this.mGoogleCode,
      };
      tData.ChainData = [];
      this.mFormData.forEach((element) => {
        let tItem = {};
        tItem.ChainType = element.ChainType;
        tItem.State = Number(element.State);
        tData.ChainData.push(tItem);
      });
      app.post("/game/chain_update_state", tData, (res) => {
        if (res.code == 200) {
          this.$message.success(this.$t('EditSuccess'));
          this.dialogData.show = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-checkbox {
  width: 80px;
}
</style>
